import "./index.css";
import { clsx } from "clsx";
import { CardHeader } from "./CardHeader";
import { CardBody, CardFooter } from "./CardSections";
import type { ICardProps } from "./types";

const CardRoot = ({ variant = "surface", className, ...props }: ICardProps) => (
  <div
    {...props}
    className={clsx("nuco-card", `nuco-card--${variant}`, className)}
  />
);

export const Card = Object.assign(CardRoot, {
  Header: CardHeader,
  Body: CardBody,
  Footer: CardFooter,
});
